import React, { useContext, useState } from "react";
import { TableRow, TableCell } from "@material-ui/core";
import { IconButtonDatatable, ModalDeleteConfirm, TableWrapper } from "App/Component/ui";
import { formatRupiah, isNull } from "App/utils/helpers";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import { PencilIcon, TrashIcon } from "App/Assets";
import ModalDetail from "./ModalDetail";
import { FormContext } from "../../context/FormContext";

export const USER = localStorage.getItem("user_name");
export const urlUpload = "/wmsAsset/request/upload_tor";

export default function ListDetailPengerjaan() {
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(false);
  const { listDetailWork, setListDetailWork, setFormDetailWork, formDetail } = useContext(FormContext);

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: listDetailWork,
    orderByDefault: "index",
    orderByRow: ["index", "status", "pembelian"],
  });

  const headCells = [
    {
      id: "no",
      disablePadding: false,
      label: "NO",
      align: "center",
      sort: false,
      maxWidth: "80px",
    },
    {
      id: "act",
      disablePadding: false,
      label: "ACTION",
      align: "left",
      sort: false,
    },
    {
      id: "status",
      disablePadding: false,
      label: "KETERANGAN PENGERJAAN",
      align: "left",
      sort: true,
      minWidth: "200px",
    },
    {
      id: "pembelian",
      disablePadding: false,
      label: "PEMBELIAN",
      align: "left",
      sort: true,
      minWidth: "150px",
    },
    {
      id: "harga",
      disablePadding: false,
      label: "HARGA",
      align: "left",
      sort: false,
      minWidth: "180px",
    },
  ];

  async function deleteList() {
    let checkPengerjaan = [];
    console.log(deleteIndex);
    checkPengerjaan = listDetailWork.filter(
      (e) => e.index !== deleteIndex.index
    );
    setListDetailWork(checkPengerjaan);
    setShowModalDeleteConfirm(false);
  }

  const handleClickDelete = (index) => {
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
    setDeleteIndex({
      index: index,
    });
  };

  const handleSelect = (row) => {
    setFormDetailWork({
      index: row?.index,
      status: row?.status,
      pembelian: row?.pembelian,
      harga: formatRupiah(row?.harga),
      onCreate:false,
    });
    setShowModalDetail(!showModalDetail);
  };

  const handleCreate = (row) => {
    setFormDetailWork({
      index: "",
      status: "",
      pembelian: "",
      harga: 0,
      onCreate:true,
    });
    setShowModalDetail(!showModalDetail);
  };

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      {showModalDetail && (
        <ModalDetail setShowModal={() => setShowModalDetail(false)} />
      )}

      <TableWrapper
        title="Daftar Pengerjaan"
        setQ={setQ}
        withAddButton={isNull(formDetail.id) ? false : true}
        clickAddButton={handleCreate}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        withSearch={true}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={listDetailWork}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        // type="CUSTOM"
        setRowsPerPage={setRowsPerPage}
      >
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                  {index + 1}.
                </TableCell>

                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "7px",
                    }}
                  >
                    <IconButtonDatatable onClick={() => handleSelect(row)}>
                      <PencilIcon />
                    </IconButtonDatatable>
                    <IconButtonDatatable
                      onClick={() => handleClickDelete(row.index)}
                    >
                      <TrashIcon />
                    </IconButtonDatatable>
                  </div>
                </TableCell>
                <TableCell align="left">{row?.status}</TableCell>
                <TableCell align="left">
                  {isNull(row?.pembelian) ? "-" : row?.pembelian}
                </TableCell>
                <TableCell align="left">
                  {isNull(row?.harga) ? "-" : formatRupiah(row?.harga)}
                </TableCell>
              </TableRow>
            );
          })}
      </TableWrapper>
    </>
  );
}
